import { render, staticRenderFns } from "./logged-users-count.vue?vue&type=template&id=899a9286&"
import script from "./logged-users-count.vue?vue&type=script&lang=js&"
export * from "./logged-users-count.vue?vue&type=script&lang=js&"
import style0 from "./logged-users-count.vue?vue&type=style&index=0&id=899a9286&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports